import SeoHead from "@/components/SeoHead";
import Content from "@/ui/Content";

export default function GalleryPage({title, canonical, content}) {
  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <Content items={content} />
    </>
  );
}

export async function getStaticProps({ }) {
  return {
    props: {
      title: "Gallery",
      canonical: "/gallery",
      content: [
        {
          component: "Placeholder"
        }
      ],
    },
  };
}